module.exports = __webpack_public_path__ + "img/miaosha.a930f7ac.png";